var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.61363 16.5303C2.04957 16.5303 1.56653 16.3293 1.16451 15.9272C0.762487 15.5252 0.561818 15.0425 0.562502 14.4791V2.17235C0.562502 1.60829 0.763513 1.12525 1.16553 0.723224C1.56756 0.321203 2.05026 0.120534 2.61363 0.121218H19.0227C19.5867 0.121218 20.0698 0.322228 20.4718 0.72425C20.8738 1.12627 21.0745 1.60897 21.0738 2.17235V14.4791C21.0738 15.0432 20.8728 15.5262 20.4708 15.9283C20.0688 16.3303 19.5861 16.531 19.0227 16.5303H2.61363ZM10.8182 9.35131L2.61363 4.22348V14.4791H19.0227V4.22348L10.8182 9.35131ZM10.8182 7.30018L19.0227 2.17235H2.61363L10.8182 7.30018ZM2.61363 4.22348V2.17235V14.4791V4.22348Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.048e312dbc0b7cc63ae6907b4b3f3df9.svg";
export { ForwardRef as ReactComponent };